<div class="container pb-2">

  <div *ngIf="PageLoading">
    <div class="text-center pt-5 pb-5">
      <div class="loader loader--style8" title="7">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="24px"
          height="30px"
          viewBox="0 0 24 30"
          style="enable-background: new 0 0 50 50"
          xml:space="preserve"
        >
          <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
            <animate
              attributeName="opacity"
              attributeType="XML"
              values="0.2; 1; .2"
              begin="0s"
              dur="0.6s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="height"
              attributeType="XML"
              values="10; 20; 10"
              begin="0s"
              dur="0.6s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="y"
              attributeType="XML"
              values="10; 5; 10"
              begin="0s"
              dur="0.6s"
              repeatCount="indefinite"
            />
          </rect>
          <rect x="8" y="10" width="4" height="10" fill="#333" opacity="0.2">
            <animate
              attributeName="opacity"
              attributeType="XML"
              values="0.2; 1; .2"
              begin="0.15s"
              dur="0.6s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="height"
              attributeType="XML"
              values="10; 20; 10"
              begin="0.15s"
              dur="0.6s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="y"
              attributeType="XML"
              values="10; 5; 10"
              begin="0.15s"
              dur="0.6s"
              repeatCount="indefinite"
            />
          </rect>
          <rect x="16" y="10" width="4" height="10" fill="#333" opacity="0.2">
            <animate
              attributeName="opacity"
              attributeType="XML"
              values="0.2; 1; .2"
              begin="0.3s"
              dur="0.6s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="height"
              attributeType="XML"
              values="10; 20; 10"
              begin="0.3s"
              dur="0.6s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="y"
              attributeType="XML"
              values="10; 5; 10"
              begin="0.3s"
              dur="0.6s"
              repeatCount="indefinite"
            />
          </rect>
        </svg>
      </div>
    </div>
  </div>
  

  <div class="row g-0 align-items-center" *ngIf="!PageLoading">

    <div *ngIf="!datapoDetail">
      <app-empty-state
        [title]="'Opps'"
        [description]="'PO tidak ditemukan.'"
        [buttonText]="'Kembali'"
        [buttonUrl]="'/dashboard'"
      ></app-empty-state>                  
    </div>
  </div>

  <div class="row g-0 align-items-center" *ngIf="!PageLoading && datapoDetail">
    <div class="col-sm-12"  *ngIf="viewBy=='procurement'">
      <app-breadcrumb
        returnAction="/dashboard"
        [breadcrumbs]="[
                          { label: 'menu.my_rfq'|translate, url: '/procurement/rfq-list' },
                          { label: 'Proforma PO Detail' }
                       ]"
      >
      </app-breadcrumb>
    </div>

    <div class="col-sm-12"  *ngIf="viewBy=='vendor'">
      <app-breadcrumb
        returnAction="/dashboard"
        [breadcrumbs]="[
                          { label: 'menu.rfq_participate'|translate, url: '/vendor/rfq-participating-in-list' },
                          { label: 'Proforma PO Detail' }
                       ]"
      >
      </app-breadcrumb>
    </div>


    <div class="col-12 mb-3">
      <div class="cd-title">
        Proforma PO Detail
      </div>
    </div>
    <div class="col-12 mb-3 cd-content">
      <div class="container py-md-3 px-md-4">
        <div class="row">
          <div class="col-12" *ngIf="viewBy=='procurement'">
            <p class="proforma-text">
              Selamat! Vendor ini telah Anda pilih untuk memenuhi pesanan berikut.<br>
              PENTING: Dokumen ini adalah Proforma PO dan belum bersifat mengikat. Silakan hubungi vendor secara langsung untuk mendapatkan PO resmi. <br>
              Dokumen ini dibuat secara otomatis. Klik <a class="cdc1" target="_blank" href="/help">di sini</a> untuk melihat syarat & ketentuan dari Cepetdapet.
            </p>
          </div>
          <div class="col-12" *ngIf="viewBy=='vendor'">
            <p class="proforma-text">
              Selamat! Perusahaan Anda telah terpilih untuk memenuhi pesanan berikut dari pelanggan.<br>
              PENTING: Dokumen ini adalah Proforma PO dan belum bersifat mengikat. Silakan hubungi pelanggan secara langsung untuk mendapatkan PO resmi.<br>
              Dokumen ini dibuat secara otomatis. Klik <a class="cdc1" target="_blank" href="/help">di sini</a> untuk melihat syarat & ketentuan dari Cepetdapet.
            </p>
          </div>

          <div class="col-12">
            <p class="fw-bold  txt-green">PPO ID : # {{formatDisplayId(datapoDetail?.poNumber)}}</p>
          </div>


          <div class="col-12  cd-text">
            <div class="row g-0 textGreen">
              <div class="col-lg-4">
                <p class="mb-0"><b>{{datapoDetail?.procurementDetailAddress?.companyName}}</b></p>
                <p class="mb-0">{{datapoDetail?.procurementDetailAddress?.companyMainStreet}}</p>
                <p class="mb-0">{{datapoDetail?.procurementDetailAddress?.companyMainCity}} {{datapoDetail?.procurementDetailAddress?.companyMainPostalCode}}</p>
                <p class="mb-0">{{datapoDetail?.procurementDetailAddress?.companyMainCountry}}<p>
              </div>

              <div class="col-lg-4">
                <p class="mb-0"><b>No Telepon</b></p>
                <p class="mb-2">{{datapoDetail?.procurementDetailAddress?.companyMainPhone || '-'}}</p>
                <p class="mb-0"><b>Email</b></p>
                <p class="mb-2">{{datapoDetail?.procurementDetailAddress?.companyMainEmail || '-'}}</p>
                <p class="mb-0"><b>Nomor Referensi Internal</b></p>
                <p class="mb-2">{{ (datapoDetail?.procurementDetailAddress?.procurementRefNumber)?datapoDetail?.procurementDetailAddress?.procurementRefNumber:'-' }}</p>
              </div>


              <div class="col-lg-4">
                <p class="mb-0"><b>Kurs Mata Uang</b></p>
                <p class="mb-2">{{ datapoDetail?.rfqCurrency }}</p>
                <p class="mb-0"><b>Tawaran ETA (Perkiraan Waktu Tiba)</b></p>
                <p class="mb-2">
                  <font *ngIf="datapoDetail?.quotationEtaOffered">{{datapoDetail?.quotationEtaOffered | date:'d MMM y'}}</font>
                  <font *ngIf="!datapoDetail?.quotationEtaOffered">-</font>
                </p>
                <p class="mb-0"><b>Termin Pembayaran</b></p>
                <p class="mb-2">{{(datapoDetail?.quotationPaymentTermInDays) ? datapoDetail?.quotationPaymentTermInDays+' Hari':'-'}}</p>

              </div>              

            </div>
          </div>

          <div class="col-12  cd-text">
            <div class="row textGreen">
              <div class="col-lg-4">
                <div class="cd-rfq-header p-3 my-3">
                  <p class="mb-0"><b>Alamat Pengiriman</b></p>
                  <p class="mb-0">{{ datapoDetail?.quotationOfferedDeliveryAddress }}</p>

                </div>

              </div>


              <div class="col-lg-8">
                <div class="cd-quotation-header p-3 my-3">
                  <div class="row">
                    <div class="col-lg-6">
                      <p class="mb-0"><b>{{datapoDetail?.vendorName}}</b></p>
                      <div [innerHtml]="convertToParagraphs(datapoDetail?.vendorAddress)"></div>
                    </div>

                    <div class="col-lg-6">

                      <p class="mb-0"><b>No Telepon</b></p>
                      <p class="mb-2">{{(datapoDetail?.vendorPhone)?datapoDetail?.vendorPhone:'-'}}</p>
                      <p class="mb-0"><b>Email</b></p>
                      <p class="mb-2">{{(datapoDetail?.vendorEmail)?datapoDetail?.vendorEmail:'-'}}</p>
                      <p class="mb-0"><b>Nomor Referensi Internal</b></p>
                      <p class="mb-2">{{ (datapoDetail?.vendorRefNumber)?datapoDetail?.vendorRefNumber:'-' }}</p>

                    </div>

                  </div>
                </div>


              </div>

            </div>
          </div>


          <div>

            <div class="cd-rfq-list-quote">
              <div class="my-2">
                <div class="table-responsive mb-2">
                  <table class="table vlistqrfq mb-0" cellpadding="10">
                    <thead>
                      <tr>
                        <th class="text-center">#</th>
                        <th class="text-left">Nomor SKU</th>
                        <th class="text-left">Merk Produk</th>
                        <th class="text-left">Nama Produk</th>
                        <th class="text-left">Deskripsi Produk</th>
                        <th class="text-center">Jumlah Dipesan</th>
                        <th class="text-center">Harga</th>
                        <th class="text-center">Total Harga</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let product of datapoDetail?.PoItem; let i = index">
                        <td class="titleVendor">{{ i+1 }}</td>
                        <td class="titleVendor">{{ product.productManufacturerCode }}</td>
                        <td class="titleVendor">{{ product.productBrand }}</td>
                        <td class="titleVendor">{{ product.productName }}</td>
                        <td class="titleVendor">
                          <font *ngIf="divDetailspecLess(product.productDescription).length>50"
                            >{{ divDetailspecLess(product.productDescription) }}</font
                          >
                          <font *ngIf="!(divDetailspecLess(product.productDescription).length>50)"
                            >{{ divDetailspec(product.productDescription) }}</font
                          >
                        </td>
                        <td class="text-end">{{ product.selectedQty | number }}</td>
                        <td class="text-end">
                          {{ datapoDetail?.rfqCurrency }} {{ product.productPrice | number }}
                        </td>
                        <td class="text-end">
                          {{ datapoDetail?.rfqCurrency }} {{ product.selectedQty *
                          product.productPrice | number }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>


            <div class="row g-0 mb-3">
              <div class="col-12 col-sm-12 cd-quote-memo">
                <!-- <p class="mb-2"><b>Memo Penawaran untuk Pelanggan</b></p>
                <p>-</p> -->
              </div>

              <div class="col-12  cd-quote-total">
              
                          <div class="row g-0">
  
                              <div class="col-sm-6"></div>
                              <div class="col-sm-3 text-end">
                                <font  *ngIf="datapoDetail?.vendorIsTaxIncluded==false">Subtotal</font>
                              </div>
                              <div class="col-sm-3 text-end pe-1">
                                <font  *ngIf="datapoDetail?.vendorIsTaxIncluded==false">{{ datapoDetail?.rfqCurrency }} {{totalQuotationPrice | number}}</font>
                                
                              </div>
  
  
  
                              <!-- "vendorIsTaxIncluded": false,
                              "vendorTaxPercentage": 10,
                              "vendorTaxValue": null, -->
                              <div class="col-12" *ngIf="datapoDetail?.vendorIsTaxIncluded==false">
                                  <div class="row g-0">
                                      <div class="col-sm-6"></div>
                                      <div class="col-sm-3 text-end" >

                                          <ng-container *ngIf="datapoDetail?.vendorTaxValue">Tax</ng-container>
                                          <ng-container *ngIf="datapoDetail?.vendorTaxPercentage">Tax({{datapoDetail?.vendorTaxPercentage}}%)</ng-container>

                                      </div>
                                      <div class="col-sm-3 text-end pe-1">

                                        <ng-container *ngIf="datapoDetail?.vendorTaxValue">{{ datapoDetail?.rfqCurrency }} {{datapoDetail?.vendorTaxValue | number}}</ng-container>
                                        <ng-container *ngIf="datapoDetail?.vendorTaxPercentage">{{ datapoDetail?.rfqCurrency }} {{datapoDetail?.vendorTaxPercentage * totalQuotationPrice /100 | number}}</ng-container>

                                      </div>        
                                  </div>
                              </div>
  
                              
                              <div class="col-sm-6"></div>
                              <div class="col-sm-3 text-end"><strong>Total</strong></div>
                              <div class="col-sm-3 text-end pe-1">
                                  <strong>
                                    
                                    <ng-container *ngIf="datapoDetail?.vendorTaxValue">
                                        {{ datapoDetail?.rfqCurrency }} {{totalQuotationPrice + datapoDetail?.vendorTaxValue | number}}
                                    </ng-container>
                                    
                                    <ng-container *ngIf="datapoDetail?.vendorTaxPercentage">
                                        {{ datapoDetail?.rfqCurrency }} {{totalQuotationPrice + (datapoDetail?.vendorTaxPercentage * totalQuotationPrice /100) | number}}
                                    </ng-container>

                                    <ng-container *ngIf="datapoDetail?.vendorIsTaxIncluded==true">
                                        {{ datapoDetail?.rfqCurrency }} {{totalQuotationPrice | number}}
                                    </ng-container>
                                    
                                  </strong>

                                  
                              </div>
  
                          </div>              
              
              </div>
            </div>
                        

          </div>

        </div>
      </div>
    </div>

  </div>
</div>


      <!-- Fixed Bottom Button -->
      <div class="fixed-bottom shadow">
  
  
  
          <div class="" [ngStyle]="{'display':displaytimeline}">
              <div class="divtimeline p-1">
              <div class="card timelinecard">
                  <div class="card-header bgtimelineheader">
                  <div class="row p-0 ">
                      <div class="col-9">
                      Quotation Status Timeline
                      </div>
                      <div class="col-3 text-end">
                      <i class="bi bi-x-lg text-end pointer" (click)="OpenModalTimeLine()"></i>
                      </div>
                  </div>
  
          
                  </div>
                  <div class="card-body">
  
                  <div class="timeline">
                      <div class="timeline__event  animated fadeInUp delay-3s timeline__event--type1 {{ StatusApproval==4 ? 'activeLine':'inactiveLine' }} inactiveIcon {{ (StatusApproval==2 || StatusApproval==4) ? 'activeIcon':'' }}"  [ngClass]="{'activeTimeline': (StatusApproval==2 || StatusApproval==4) && Valstate=='UNPUBLISHED'}">
                      <div class="timeline__event__icon ">
                          <i class="lni-cake"></i>
                          <div class="timeline__event__date inactiveTimeline"  [ngClass]="{'activeTimeline': (StatusApproval==2 || StatusApproval==4)}">
                          Approval<br>Requested
                          </div>
                      </div>
                      </div>
                      <div class="timeline__event animated fadeInUp delay-2s timeline__event--type2 inactiveIcon {{ StatusApproval==4  ? 'activeIcon':'' }} {{ StatusApproval==4 && Valstate=='PUBLISHED' ? 'activeLine':'inactiveLine' }} ">
                      <div class="timeline__event__icon">
                          <i class="lni-burger"></i>
                          <div class="timeline__event__date inactiveTimeline {{ Valstate!=='UNPUBLISHED' ? 'activeTimeline':'' }}" [ngClass]="{'activeTimeline': StatusApproval==4}">
                            Quotation<br>Approved
                          </div>
                      </div>
                      </div>
                      <div class="timeline__event animated fadeInUp delay-1s timeline__event--type3 inactiveIcon {{ StatusApproval==4 && Valstate=='PUBLISHED'  ? 'activeIcon':'' }}" style="margin-bottom: 10px !important;">
                      <div class="timeline__event__icon">
                          <i class="lni-slim"></i>
                          <div class="timeline__event__date inactiveTimeline" [ngClass]="{'activeTimeline': StatusApproval==4 && Valstate=='PUBLISHED'}">
                          Publish<br>Quotation
                          </div>
                      </div>
                      </div>
  
                  
                  </div>
                  <div class="text-center">
                      <p class="texttimeline" [hidden]='StatusApproval!==1'>Click the “Request Approval” button to process product listing. </p>
                      <p class="texttimeline" [hidden]='StatusApproval!==2'>Please wait, your Quotation is being review</p>
                      <p class="texttimeline" [hidden]='StatusApproval!==4'>
   
                        <font *ngIf='Valstate=="UNPUBLISHED"'>Your Quotation is has been approved</font>
                        <font *ngIf='Valstate=="PUBLISHED"'>Your Quotation is has been approved & published</font>
                        
                      </p>
                      
  
  
                      <button type="button" (click)="reqeustApproval(quotationId,'REQUEST')" class="btn btn-dark fhbcyan rounded-1 mb-2"  *ngIf="!LoadingreqeustApproval" [hidden]='StatusApproval!==1'>Request Approval</button>
                      <button type="button" class="btn btn-dark fhbcyan rounded-1 mb-2 disabled"  *ngIf="LoadingreqeustApproval" [hidden]='StatusApproval!==1' disabled>Loading...</button>
          
          
  
          
                      <button type="button" (click)="openModalApproveReject()" *ngIf="CanApproveReject" class="btn fhbcyan w-100 rounded-1 mb-2 text-center text-white pt-2 pb-2" [hidden]='StatusApproval!==2'>Approval Requested</button>
                      
          
                      <font *ngIf="!CanApproveReject" class="fhbcyan rounded-1 mb-2 text-center text-white pt-2 pb-2 ps-3 pe-3" [hidden]='StatusApproval!==2'>Approval Requested</font>
          
          
          
                      
                      <font class="fhbcyan rounded-1 mb-2 text-center text-white pt-2 pb-2 txtdisabled ps-3 pe-3" *ngIf='StatusApproval==4 && Valstate=="UNPUBLISHED"'>Approved</font>
                      <font class="fhbcyan rounded-1 mb-2 text-center text-white pt-2 pb-2 txtdisabled ps-3 pe-3"  *ngIf='StatusApproval==4 && Valstate=="PUBLISHED"'>Published</font>
  
                      
  
  
                  </div>
  
  
                  </div>
              </div>
              </div>
              
          </div>
  
  
  
          
        <div class="bg-white pt-3 pb-3">
          <div class="container">
            <div class="row">
              <div class="col-sm-6 d-none d-sm-block">
                <a class="btn btn-link rounded-1 roundedmore mb-0 ms-0 ms-sm-3 ps-4 pe-4 c1" (click)="back()"><strong>Back</strong></a>
              </div>
              <div class="col-12 col-sm-6 text-end">
  
                <a type="button" class="btn btn-primary fhbcyan rounded-1 roundedmore mb-0 ms-sm-3 ps-sm-4 pe-sm-4 w100" href="/po/export/pdf/{{PoId}}">Download PDF</a>
                
              </div>
            </div>
          </div>
        </div>
      </div>
  

<div class="bg5 pt-0 pt-sm-3 pb-3 d-none isHide">

    <div class="container">
  
      <!-- Breadcrumb -->
      <div class="d-none d-sm-block">
      <div class="divshbreadcum mt-3 mb-4 pt-2 pb-2 pe-3 ps-3">
        <div class="row">
          <div class="col-sm-12">
            <div class="shbreadcum">
              <table *ngIf="viewBy=='procurement'">
                <tr>
                  <td class="separator">
                    <h6 class="pt-2 mt-1 me-3">
                      <strong>
                        <a (click)="back()" class="c1 pointer">
                          <img src="/assets/images/icons/ic_round-navigate-next.png" class="backicon"> Back
                        </a>
                      </strong>
                    </h6>
                  </td>
                  <td>
                    <h6 class="mb-1 mt-2 ms-3">
                      <strong class="c1">
                        <a class="c1 pointer" href="/procurement/rfq-list">My RFQ</a> > <font class="text-muted">Proforma PO Detail</font>
                      </strong>
                      
                    </h6>
                  </td>
                </tr>
              </table>
              <table *ngIf="viewBy=='vendor'">
                <tr>
                  <td class="separator">
                    <h6 class="pt-2 mt-1 me-3">
                      <strong>
                        <a (click)="back()" class="c1 pointer">
                          <img src="/assets/images/icons/ic_round-navigate-next.png" class="backicon"> Back
                        </a>
                      </strong>
                    </h6>
                  </td>
                  <td>
                    <h6 class="mb-1 mt-2 ms-3">
                      <strong class="c1">
                        <a class="c1 pointer" href="/vendor/rfq-board">RFQ</a> > <a class="c1 pointer" href="/vendor/rfq-participating-in-list"> Participating In > </a> <a class="c1 pointer" (click)="back()"> Detail Quotation > </a> <font class="text-muted">Proforma PO Detail</font>
                      </strong>
                    </h6>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <!-- <div class="col-sm-5">
          </div> -->
        </div>
      </div>
      </div>
      <div class="d-block d-sm-none">
        <div class="divshbreadcum mt-3 mb-4 pt-2 pb-2 pe-3 ps-3">
        <div class="row">
          <div class="col-10">
            <div class="pt-1">
              <strong class="c1">
                <!-- <font class="c1 pointer" >Vendor</font> >  -->
                <font class="c2">Proforma PO Detail
                </font>
              </strong>
            </div>

          </div>
          <div class="col-2 text-end">
          </div>
        </div>
        </div>
      </div>
  
      <div class="mt-3">
  
        <!-- Saat page loading -->
        <div *ngIf="PageLoading">
          <div class="text-center pt-5 pb-5">
            <div class="loader loader--style8" title="7">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="30px" viewBox="0 0 24 30"
                style="enable-background:new 0 0 50 50;" xml:space="preserve">
                <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
                  <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s"
                    repeatCount="indefinite" />
                  <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s"
                    repeatCount="indefinite" />
                  <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s"
                    repeatCount="indefinite" />
                </rect>
                <rect x="8" y="10" width="4" height="10" fill="#333" opacity="0.2">
                  <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s"
                    repeatCount="indefinite" />
                  <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s"
                    repeatCount="indefinite" />
                  <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s"
                    repeatCount="indefinite" />
                </rect>
                <rect x="16" y="10" width="4" height="10" fill="#333" opacity="0.2">
                  <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s"
                    repeatCount="indefinite" />
                  <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s"
                    repeatCount="indefinite" />
                  <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s"
                    repeatCount="indefinite" />
                </rect>
              </svg>
            </div>
          </div>
        </div>
  
        <!-- Saat page tidak loading -->
        <div class="pb-5" *ngIf="!PageLoading">
  
          <!-- Jika RFQ tidak ditemukan  -->
          <div *ngIf="!DataQuotation" class="empty-product">
            <div class="bg-secondary bg-gradient rounded-3 pt-5 pb-5 mb-5 text-center">
              <h1 class="text-light bi bi-file-earmark-ruled" style="font-size: 80px;"></h1>
              <h6 class="text-light">PO Not Found.</h6>
            </div>
          </div>
  
  
          <!-- Jika ada RFQ -->
          <div class="mb-4" *ngIf="getPoListData != []">

            <!-- Quotation -->
            <form [formGroup]="rfqForm" (ngSubmit)="onSubmit()">
              <div class="container pt-2 pb-5" id="rfqFormDiv">
                <div class="row pb-5">
                  <div class="col-md-12 divprodlist">
                    <div class="row rounded-top fhbgcyan text-white">
                      <div class="col-sm-12 mt-0 pt-3 mb-3 ps-3 ps-sm-5">
                        <h4 class="mb-0 fw-bold">Proforma PO Detail
                        </h4>
                      </div>
                    </div>
                    <!-- Detail -->
                    <!-- Section 1 a-->
  
                    <!-- Line break -->
                    <div class="row">
                      <div class="col-sm-12 px-3 px-sm-5 my-3 my-sm-4">
                          <small class="fhnotes">
                              <strong>
                              Congratulations! Your company has been selected to fulfill below order by the customer. <br>
                              IMPORTANT : Please note that this is Proforma PO and is NOT binding. Please Contact the customer for a binding PO. This is a auto-generated Proforma PO. Please click <a class="pointer c1"><u>here to Review FH terms and conditions</u></a>.
                              </strong>
                          </small>
                      </div>
                    </div>
                    
                    <div class="row px-3 px-sm-5 mb-3">
                        <div class="col-sm-6 p-0 mb-3">
                              <div class="potable">
                                  <div class="row">
                                    <div class="col-sm-2"></div>
                                    <div class="col-sm-8">
                                      <b>{{datapoDetail?.procurementDetailAddress?.companyName}}</b>
                                      <br>
                                      {{datapoDetail?.procurementDetailAddress?.companyMainStreet}}<br>
                                      {{datapoDetail?.procurementDetailAddress?.companyMainCity}} {{datapoDetail?.procurementDetailAddress?.companyMainPostalCode}}<br>
                                      {{datapoDetail?.procurementDetailAddress?.companyMainCountry}}<br>
                                      <table>
                                        <tr>
                                          <td>Phone</td>
                                          <td class="ps-2 pe-2">:</td>
                                          <td>{{datapoDetail?.procurementDetailAddress?.companyMainPhone}}</td>
                                        </tr>
                                        <tr>
                                          <td>Email</td>
                                          <td class="ps-2 pe-2">:</td>
                                          <td>{{datapoDetail?.procurementDetailAddress?.companyMainEmail}}</td>
                                        </tr>
                                        <tr>
                                          <td class="fw-bold">Internal Ref. No.</td>
                                          <td class="ps-2 pe-2 fw-bold">:</td>
                                          <td class="fw-bold">{{ (datapoDetail?.procurementDetailAddress?.procurementRefNumber)?datapoDetail?.procurementDetailAddress?.procurementRefNumber:'-' }}</td>
                                        </tr>
                                      </table>
                                    </div>
                                    <div class="col-sm-2"></div>
                                  </div>

                                

                              </div>
                        </div>
                        <div class="col-sm-6  p-0 mb-3">
                            <div class="row">
                              <div class="col-sm-3"></div>
                              <div class="col-sm-6">

                
                                <table>
                                  <tr>
                                    <td><h6 class="c1"><strong>PO Id </strong></h6></td>
                                    <td><h6 class="c1"><strong class="ps-2 pe-2">:</strong></h6></td>
                                    <td><h6 class="c1"><strong># {{formatDisplayId(datapoDetail?.poNumber)}}</strong></h6></td>
                                </tr>
                                  <tr>
                                      <td><strong>Currency</strong></td>
                                      <td><strong class="ps-2 pe-2">:</strong></td>
                                      <td>{{ datapoDetail?.rfqCurrency }}</td>
                                  </tr>
                                  <tr>
                                      <td><strong>ETA Offered</strong></td>
                                      <td><strong class="ps-2 pe-2">:</strong></td>
                                      <td>
                                        <font *ngIf="datapoDetail?.quotationEtaOffered">{{datapoDetail?.quotationEtaOffered | date:'d MMM y'}}</font>
                                        <font *ngIf="!datapoDetail?.quotationEtaOffered">-</font>
                                        </td>
                                  </tr>
                                  <tr>
                                      <td><strong>Payment Term</strong></td>
                                      <td><strong class="ps-2 pe-2">:</strong></td>
                                      <td>{{(datapoDetail?.quotationPaymentTermInDays) ? datapoDetail?.quotationPaymentTermInDays+' Days':'-'}}</td>
                                  </tr>
                              </table>

                              </div>
                              <div class="col-sm-3"></div>



                            </div>
                      </div>
                    </div>
  
                    <div class="row p-3">
                        <div class="col-sm-6">
                          <div class="row justify-content-center">
                              <div class="col-12 col-sm-8 m-3 m-sm-0 rfq-detail-quote p-4">
                                <div class="p-3 p-sm-0">
                                    <div class="row">
  
   
                                      <div class="col-12 text-start fw-bold ">Shipping Address</div>
                                        <!-- <div class="col-12 text-start fw-bold">Shipping Address</div> -->
                                        <div class="col-12  text-start">
                                          {{ datapoDetail?.quotationOfferedDeliveryAddress }}
                                          <br>
                                        
                                        </div>
                                    </div>
                                </div>
                              </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="row justify-content-center">
                              <div class="col-12 col-sm-8 m-3 m-sm-0 rfq-detail-quote-vendor p-4">
                                <div class="p-3 p-sm-0">
                                    <div class="row">
                                      <div class="col-12 text-start fw-bold c1">{{datapoDetail?.vendorName}}</div>
                                      <div class="col-12">
                                        {{datapoDetail?.vendorAddress}}<br><br>
                                        Phone : {{(datapoDetail?.vendorPhone)?datapoDetail?.vendorPhone:'-'}}<br>
                                        Email : {{(datapoDetail?.vendorEmail)?datapoDetail?.vendorEmail:'-'}}<br>
                                        <div class="text-start fw-bold">Internal Ref. No. : {{ (datapoDetail?.vendorRefNumber)?datapoDetail?.vendorRefNumber:'-' }}</div>
                                      </div>


                                    </div>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
  
  
  
                    <!-- Section 2 -->
                    <div class="row">
                      <!-- <div class="col-sm-10 p-5 pt-3 pb-1">
                        <label class="c1" for="listproduct"><strong>Total Vendor : {{ datapoDetail?.poListData.length }}</strong></label>
                      </div>
                      <div class="col-sm-2 p-5 pt-3 pb-1">
                      </div> -->
                      <!-- Product List -->
                      <div class="col-sm-12 p-3 p-sm-5  pb-2 pb-sm-2 pb-0">
                        <div class="mb-3 mt-5 row">
                          <div class="container">
  
  
                              <div class="table-responsive">
                                  <table class="table tableqrfq mb-0">
                                      <tr>
                                          <th class="text-center">#</th>
                                          <th class="text-left">Manf. Prod. No.</th>
                                          <th class="text-left">Brand</th>
                                          <th class="text-left">Product Name</th>
                                          <th class="text-left">Product Description</th>
                                          <th class="text-center">QTY Offer</th>
                                          <th class="text-center">Price</th>
                                          <th class="text-center">Line Total</th>
                                      </tr>
                                      <tr *ngFor="let product of datapoDetail?.PoItem; let i = index">
  
      
                                          <td class="titleVendor">{{ i+1 }}</td>
                                          <td class="titleVendor">{{ product.productManufacturerCode }}</td>
                                          <td class="titleVendor">{{ product.productBrand }}</td>
                                          <td class="titleVendor">{{ product.productName }}</td>
                                          <!-- <td class="titleVendor">{{ divDetailspec(product.productDescription) }}</td> -->
                                          <td class="titleVendor">
                                            <font *ngIf="divDetailspecLess(product.productDescription).length>50">{{ divDetailspecLess(product.productDescription) }}</font>
                                            <font *ngIf="!(divDetailspecLess(product.productDescription).length>50)">{{ divDetailspec(product.productDescription) }}</font>
                                          </td>
                                          <td class="text-end">{{ product.selectedQty | number }}</td>
                                          <td class="text-end">{{ datapoDetail?.rfqCurrency }} {{ product.productPrice | number }}</td>
                                          <td class="text-end">{{ datapoDetail?.rfqCurrency }} {{ product.selectedQty * product.productPrice | number }}</td>
                                      </tr>
                                  </table>
                              </div>
  
  
                          </div>
                        </div>
                      </div>
                    </div>
  
  
                    <div class="row pb-5">
                      <div class="col-sm-12 p-3 p-sm-5 pt-2 pt-sm-2 pb-0">
                        <div class="mb-3">
                          <div class="row g-0">
  
                              <div class="col-sm-6"></div>
                              <div class="col-sm-3 text-end">
                                <font  *ngIf="datapoDetail?.vendorIsTaxIncluded==false">Subtotal</font>
                              </div>
                              <div class="col-sm-3 text-end pe-1">
                                <font  *ngIf="datapoDetail?.vendorIsTaxIncluded==false">{{ datapoDetail?.rfqCurrency }} {{totalQuotationPrice | number}}</font>
                                
                              </div>
  
  
  
                              <!-- "vendorIsTaxIncluded": false,
                              "vendorTaxPercentage": 10,
                              "vendorTaxValue": null, -->
                              <div class="col-12" *ngIf="datapoDetail?.vendorIsTaxIncluded==false">
                                  <div class="row g-0">
                                      <div class="col-sm-6"></div>
                                      <div class="col-sm-3 text-end" >

                                          <ng-container *ngIf="datapoDetail?.vendorTaxValue">Tax</ng-container>
                                          <ng-container *ngIf="datapoDetail?.vendorTaxPercentage">Tax({{datapoDetail?.vendorTaxPercentage}}%)</ng-container>

                                      </div>
                                      <div class="col-sm-3 text-end pe-1">

                                        <ng-container *ngIf="datapoDetail?.vendorTaxValue">{{ datapoDetail?.rfqCurrency }} {{datapoDetail?.vendorTaxValue | number}}</ng-container>
                                        <ng-container *ngIf="datapoDetail?.vendorTaxPercentage">{{ datapoDetail?.rfqCurrency }} {{datapoDetail?.vendorTaxPercentage * totalQuotationPrice /100 | number}}</ng-container>

                                      </div>        
                                  </div>
                              </div>
  
                              
                              <div class="col-sm-6"></div>
                              <div class="col-sm-3 text-end"><strong>Total</strong></div>
                              <div class="col-sm-3 text-end pe-1">
                                  <strong>
                                    
                                    <ng-container *ngIf="datapoDetail?.vendorTaxValue">
                                        {{ datapoDetail?.rfqCurrency }} {{totalQuotationPrice + datapoDetail?.vendorTaxValue | number}}
                                    </ng-container>
                                    
                                    <ng-container *ngIf="datapoDetail?.vendorTaxPercentage">
                                        {{ datapoDetail?.rfqCurrency }} {{totalQuotationPrice + (datapoDetail?.vendorTaxPercentage * totalQuotationPrice /100) | number}}
                                    </ng-container>

                                    <ng-container *ngIf="datapoDetail?.vendorIsTaxIncluded==true">
                                        {{ datapoDetail?.rfqCurrency }} {{totalQuotationPrice | number}}
                                    </ng-container>
                                    
                                  </strong>

                                  
                              </div>
  
                          </div>
                        </div>
                      </div>
                    </div>
                    
  
                    <!-- Section 2 alternative -->
                    <div class="row"  *ngIf="alternativeItemList.length>0">
                      <div class="col-sm-10 p-5 pt-3 pb-1">
                        <label class="" for="listproductalt"><strong>Product You Might be Interested</strong></label>
                      </div>
                      <div class="col-sm-2 p-5 pt-3 pb-1">
                      </div>
                      <!-- Product List -->
                      <div class="col-sm-12 p-5 pt-0 pb-0">
                        <div class=" row">
                          <div class="container">
                            <ul class="list-group rounded-0">
  
                              <li class="list-group-item bg1 p-0 mb-3 rounded shadow border-0 b1 hvshadow"
                                *ngFor="let product of alternativeItemList; let i = index"
                                [ngClass]="{ 'bg4': submitted && (CheckVal(ValmanufacturerSku[i]) || CheckVal(Valbrand[i]) || CheckVal(ValqtyNeeded[i]) ) }">
                                <div class="row m-0 p-0 pointer" (click)="AccordionHideShowAlt(i)">
                                  <div class="col-sm-1 p-2 ps-3 fw-bold text-white">{{i+1}}</div>
                                  <div class="col-sm-10 p-2 text-center text-white">
                                    <!-- <strong>{{ mappingProductfromRfq(product.rfqItemId,'brand') }} </strong> : {{ mappingProductfromRfq(product.rfqItemId,'name') }} -->
                                  <strong>{{ product.alternativeProductBrand }}</strong> : {{ product.alternativeProductName }}
                                  
                                  </div>
                                  <div class="col-sm-1 p-2 text-end fw-bold text-white">
                                    <img
                                      src="/assets/images/icons/{{ (product.collapse) ? 'ic_Dup@2x.png':'ic_Ddown@2x.png' }}"
                                      class="ps-2 pe-2 icondropdown">
                                  </div>
                                </div>
                                <!-- Expanded Content -->
                                <div
                                  class="bg-white divshadow m-0 p-5 pt-4 rounded-bottom row {{ (product.collapse) ? '':'d-none' }}">
                                  <strong class="text-end">Reffer to : {{mappingProductfromRfq(product.rfqItemId,'description')}}</strong>
                                  <p><b>Your Offer : </b></p>
                                  <div class="col-sm-12 p-4 ms-0 me-5 mb-4 product-detail-quote">
  
                                    <div class="row mt-2">
                                      <div class="col-2 text-start fw-bold">Product Name</div>
                                      <div class="col-1 text-center">:</div>
                                      <div class="col-2 text-start">{{ product.alternativeProductName }}</div>
                                      <div class="col-2"></div>
                                      <div class="col-2 text-start fw-bold">Price</div>
                                      <div class="col-1 text-center">:</div>
                                      <div class="col-2 text-start">{{ product.priceOffered | number }}</div>
                                    </div>
                                    <div class="row mt-2">
                                      <div class="col-2 text-start fw-bold">Brand</div>
                                      <div class="col-1 text-center">:</div>
                                      <div class="col-2 text-start">{{ product.alternativeProductBrand }}</div>
                                      <div class="col-2"></div>
                                      <div class="col-2 text-start fw-bold">QTY Offered</div>
                                      <div class="col-1 text-center">:</div>
                                      <div class="col-2 text-start">{{ product.qtyOffered }}</div> 
                                    </div>
                                    <div class="row mt-2">
                                      <div class="col-2 text-start fw-bold">Manf. Prod. No.</div>
                                      <div class="col-1 text-center">:</div>
                                      <!-- <div class="col-2 text-start" [innerHTML]="divspec(product.description)"></div> -->
                                      <div class="col-2 text-start">{{ product.alternativeProductManufacturerCode }}</div>
  
                                      
                                      <div class="col-2"></div>
                                      <div class="col-2 text-start fw-bold">Line Total</div>
                                      <div class="col-1 text-center">:</div>
                                      <div class="col-2 text-start">
                                        
                                        {{ product.priceOffered * product.qtyOffered | number }}
  
                                      </div>
                                    </div>
                                    <div class="row mt-2">
                                      <div class="col-2 text-start fw-bold">Product Description</div>
                                      <div class="col-1 text-center">:</div>
                                      <!-- <div class="col-2 text-start" [innerHTML]="divspec(product.description)"></div> -->
                                      <div class="col-2 text-start">{{product.alternativeProductDesc }}</div>
                                      <div class="col-2"></div>
                                      <div class="col-2 text-start fw-bold">Specification</div>
                                      <div class="col-1 text-center">:</div>
                                      <div class="col-2 text-start"></div>
                                    </div>
                                  </div>
  
                                </div>
  
  
  
  
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
  
  
  
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  

  